import {
  Ref,
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
} from 'react'

import { Menu, Position, Trigger } from '@joor/design-system'
import styled from 'styled-components'

import { GridApi } from 'components/AgGrid/types'

import { useAgGridFilters } from './agGridFilters.hooks'
import { FilterDef, ValuesData } from './agGridFilters.types'

const StyledMenu = styled(Menu)`
  z-index: 2;

  & > div:nth-child(2) {
    width: 240px;
  }
`

type Props = {
  valuesData?: ValuesData
  filterDefs: FilterDef[]
  gridApi?: GridApi | null
  disabled?: boolean
  hideSearch?: boolean
  menuPosition?: Position
  isDataSettled?: boolean
  id?: string
}

export type AgGridFiltersRef = {
  resetFilters: () => void
}

export const AgGridFilters = forwardRef(
  (
    {
      valuesData = {},
      filterDefs,
      gridApi,
      disabled,
      hideSearch,
      menuPosition = 'right',
      isDataSettled = false,
      id,
    }: Props,
    ref: Ref<AgGridFiltersRef>,
  ) => {
    const [uniqueValuesByFilter, setUniqueValuesByFilter] = useState<
      Record<string, string[]>
    >({})
    const { options, resetFilters } = useAgGridFilters({
      valuesData,
      filterDefs,
      gridApi,
      hideSearch,
      uniqueValuesByFilter,
    })

    useEffect(() => {
      if (!gridApi || !isDataSettled) return

      const uniqueValues = filterDefs.reduce<Record<string, string[]>>(
        (acc, { name }) => ({
          ...acc,
          [name]:
          // @ts-ignore
            (gridApi?.getFilterInstance(name)?.getValues?.() as string[]) ?? [],
        }),
        {},
      )

      setUniqueValuesByFilter(uniqueValues)
    }, [filterDefs, gridApi, isDataSettled])

    useImperativeHandle(ref, () => ({
      resetFilters,
    }))

    return (
      <StyledMenu
        disabled={disabled}
        options={options}
        position={menuPosition}
        autoClose
        autoCloseOptions={{ excludeIds: ['ag-grid-filters-date-picker_modal'] }}
        trigger={<Trigger iconName="filter" label="Filters" />}
        id={id}
      />
    )
  },
)
